module.exports = __webpack_public_path__ + "img/about_title2.522c3d43.png";